import { useAsyncData, useCookie, useRuntimeConfig } from "#imports";
import { useSiteUtils } from "@voix/composables/useSiteUtils";
import { useVoixToast } from "@voix/composables/useVoixToast";
import { useAdminStore } from "@voix/store/adminStore";
export async function useVoixAsyncData(request, options = {}) {
  const config = useRuntimeConfig();
  const { getCurrentDomain } = useSiteUtils();
  const domain = getCurrentDomain();
  const headers = {
    "X-VOIX-SITE": domain,
    "X-VOIX-ENV": config.public.voixEnv,
    "accept": "application/json"
  };
  const adminStore = useAdminStore();
  const releasePreviewHeader = adminStore.releaseId;
  if (releasePreviewHeader)
    headers["X-VOIX-RELEASE-PREVIEW"] = releasePreviewHeader;
  const accessToken = useCookie("auth-access-token");
  if (accessToken.value && (request.includes("api/admin") || options?.sendAuthHeader === true))
    headers.authorization = `Bearer ${accessToken.value}`;
  const randomString = Math.random().toString(36).substring(7);
  const requestKey = options.method && (options.method.toLowerCase() === "put" || options.method.toLowerCase() === "post") ? request + randomString : request;
  const theRequest = await useAsyncData(
    requestKey,
    async () => $fetch(
      `${config.public.voixApiBaseUrl}${request}`,
      {
        ...options,
        headers: {
          ...headers,
          ...options?.headers
        }
      }
    )
  );
  const errorValue = theRequest.error.value;
  if (errorValue) {
    const voixToast = useVoixToast();
    if (errorValue.data) {
      const errorValueData = errorValue.data;
      switch (errorValueData.statusCode) {
        case 401:
          console.warn("Voix Nuxt API: Route to login");
          break;
        case 422:
          if (errorValueData.data?.errors) {
            Object.keys(errorValueData.data?.errors).forEach((key) => {
              errorValueData.data?.errors[key].forEach((validationError) => {
                voixToast.add(validationError, "error");
              });
            });
          } else {
            voixToast.add(errorValueData.message, "error");
          }
          break;
        default:
          console.error("Voix Nuxt API:", theRequest.error);
          voixToast.add(errorValueData.message, "error");
          break;
      }
    } else {
      console.error("Voix Nuxt API:", errorValue);
    }
  }
  const asyncDataPromise = Promise.resolve(theRequest).then(() => theRequest);
  Object.assign(asyncDataPromise, theRequest);
  return asyncDataPromise;
}
